export default __webpack_public_path__ + "18d6932b09388212ee9e79685110c54d.jpg";